import { render, staticRenderFns } from "./TeamRequestOverview.vue?vue&type=template&id=58e67367&scoped=true"
import script from "./teamRequestOverview.ts?vue&type=script&lang=ts&external"
export * from "./teamRequestOverview.ts?vue&type=script&lang=ts&external"
import style0 from "./TeamRequestOverview.vue?vue&type=style&index=0&id=58e67367&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e67367",
  null
  
)

export default component.exports